import { DOCUMENT } from '@angular/common';
import { Component, OnInit, Output, EventEmitter, Input, OnDestroy, Inject, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { WebcamImage, WebcamInitError, WebcamUtil } from 'ngx-webcam';
import { Observable, Subject } from 'rxjs';

declare var $: any;

@Component({
	selector: 'app-camera',
	templateUrl: './camera.component.html',
	styleUrls: ['./camera.component.scss'],
})
export class CameraComponent implements OnInit {
	@ViewChild('clickSound') clickSound: ElementRef
	@Output()
	public pictureTaken = new EventEmitter<WebcamImage>();

	@Output()
	public permissionDenied = new EventEmitter<void>();

	@Input()
	public message: string;
	@Input()
	public imageQuality: number = 1;

	@Input()
	public webcamMirrorProperties = "never";

	@Input() apiTime: number;
	@Input()
	public facingMode: string = 'user';
	public showWebcam = false;
	public allowCameraSwitch = false;
	public multipleWebcamsAvailable = false;
	public deviceId: string;
	public consecutiveDetections: number = 0;
	public setfalsedetection: boolean = false;
	public setfardetection: boolean = false;
	public detectinterval: any;
	public get videoOptions(): MediaTrackConstraints {

		const result: MediaTrackConstraints = {
			width: { ideal: 640 },
			height: { ideal: 480 },
			frameRate: {
				min: 20,
				ideal: 30,
				max: 60
			}
		};
		// width: { ideal: 350 },
		// 	height: { ideal: 280 },
		if (this.facingMode && this.facingMode !== '') {
			result.facingMode = { ideal: this.facingMode };
		}

		return result;
	}
	private trigger: Subject<void> = new Subject<void>();
	private nextWebcam: Subject<boolean | string> = new Subject<
		boolean | string
	>();

	doc: Document;

	isSelfieCorrect: boolean = false;

	// constructor(@Inject(DOCUMENT) document) {
	// 	this.doc = document;
	// }
	constructor(@Inject(DOCUMENT) public document: Document) {
		// Now you can use 'this.document' to access the Document object
	}
	public ngOnInit(): void {
		if (!this.imageQuality)
			this.imageQuality = 1;

		WebcamUtil.getAvailableVideoInputs().then(
			(mediaDevices: MediaDeviceInfo[]) => {
				this.multipleWebcamsAvailable =
					mediaDevices && mediaDevices.length > 1;
			}
		);
	}
	public triggerSnapshot(): void {
		clearInterval(this.detectinterval);
		this.playClickSound();
		this.trigger.next();
	}
	private playClickSound(): void {
		// Play the sound by calling the play() method on the audio element
		const audio: HTMLAudioElement = this.clickSound.nativeElement;
		audio.play();
	}
	public stope(): void {
		clearInterval(this.detectinterval);
		$("#camera-modal").modal("hide")

	}
	public toggleWebcam(): void {
		let me = this;
		clearInterval(this.detectinterval);
		this.showWebcam = !this.showWebcam;
		if (this.showWebcam) {
			$('#camera-modal').modal('show');
			$('#cameraModel').css('visibility', 'hidden');
			$('#loader2').css('visibility', 'visible');

			setTimeout(() => {
				this.startFaceTracking();
			}, 1000);

		} else {
			$('#camera-modal').modal('hide');
			// clearInterval(this.detectinterval);
			try {
				let constraints = {
					deviceId: this.deviceId,
					width: this.videoOptions.width,
					height: this.videoOptions.height
				};
				navigator.mediaDevices.getUserMedia({ video: constraints }).then(stream => {
					let tracks = stream.getVideoTracks();
					tracks.forEach(track => {
						track.stop();
					});
					me.deviceId = null;
				});

				let tracks = this.getStream().getVideoTracks();

				tracks.forEach(track => {
					track.stop();
				});
			} catch (e) {

			}
		}
	}

	startFaceTracking() {

		const f = this.document.getElementById('getreqired');
		const h = $('.camaeraDivOvel')
		// console.log(f.offsetWidth, f.offsetHeight)
		let videoWidth = Math.min(f.offsetWidth * 0.85, 400) + "px";
		let cir = Math.min(f.offsetWidth * 0.85, 400) + 10 + "px";

		$("video").css({ 'height': '400px', 'object-fit': 'cover', 'object-position': ' 50% 50%', 'width': '400px' })

		if (window.innerWidth > 400 && window.innerWidth < 600) {
			h.css('width', cir)
			h.css('height', cir)
			$("video").css({ 'height': videoWidth, 'width': videoWidth })
		} else if (window.innerWidth > 320 && window.innerWidth < 400) {
			$("video").css({ 'height': videoWidth, 'width': videoWidth })
			h.css('width', cir)
			h.css('height', cir)
		}

		// if ( window.innerWidth < 600){
		// 	$("video").css("height", window.innerWidth + 50)
		// }
		let me = this;
		let constraints = {
			deviceId: this.deviceId,
			width: this.videoOptions.width,
			height: this.videoOptions.height
		};
		this.bindToPlayEvent();
	}
	bindToPlayEvent() {

		setTimeout(() => {
			var stream = this.getStream();

			if (!stream)
				this.bindToPlayEvent();

			const videoEl = <HTMLVideoElement>this.document.getElementById("webcam")
			let videoPlayer = <HTMLVideoElement>videoEl.getElementsByTagName("video")[0];

			//attaching our webcam stream to the video element
			videoPlayer['srcObject'] = stream;
			videoPlayer.addEventListener('play', async (videoEl) => {
				// await this.run(videoEl);
				this.detectFace()
			});
		}, 500);
	}


	getStream(): MediaStream {
		const videoEl = <HTMLVideoElement>this.document.getElementById("webcam")
		let videoPlayer = <HTMLVideoElement>videoEl.getElementsByTagName("video")[0];
		return <MediaStream>videoPlayer['srcObject'];

	}

	cancelCamera() {
		this.toggleWebcam();
	}

	public getObjectFitSize = function (b, g, a, d, f) {
		var h = d / f
			, k = g / a;
		(b ? h > k : h < k) ? (b = g,
			k = b / h,
			d = f / k) : (k = a,
				b = k * h,
				d /= b);
		return {
			width: b,
			height: k,
			x: (b - g) * d / 2,
			y: (k - a) * d / 2,
			ratio: d
		}
	};

	public unpack_cascade = function (b: Uint8Array) {
		var g = new DataView(new ArrayBuffer(4)),
			a = 8;
		g.setUint8(0, b[a + 0]);
		g.setUint8(1, b[a + 1]);
		g.setUint8(2, b[a + 2]);
		g.setUint8(3, b[a + 3]);
		var d = g.getInt32(0, true);
		a += 4;
		g.setUint8(0, b[a + 0]);
		g.setUint8(1, b[a + 1]);
		g.setUint8(2, b[a + 2]);
		g.setUint8(3, b[a + 3]);
		var f = g.getInt32(0, true);
		a += 4;
		for (var h = [], k = [], l = [], m = 0; m < f; ++m) {
			Array.prototype.push.apply(h, [0, 0, 0, 0]);
			Array.prototype.push.apply(h, b.slice(a, a + 4 * Math.pow(2, d) - 4));
			a = a + 4 * Math.pow(2, d) - 4;
			for (var n = 0; n < Math.pow(2, d); ++n)
				g.setUint8(0, b[a + 0]),
					g.setUint8(1, b[a + 1]),
					g.setUint8(2, b[a + 2]),
					g.setUint8(3, b[a + 3]),
					k.push(g.getFloat32(0, true)),
					a += 4;
			g.setUint8(0, b[a + 0]);
			g.setUint8(1, b[a + 1]);
			g.setUint8(2, b[a + 2]);
			g.setUint8(3, b[a + 3]);
			l.push(g.getFloat32(0, true));
			a += 4;
		}
		var p: Int8Array = new Int8Array(h),
			q: Float32Array = new Float32Array(k),
			r: Float32Array = new Float32Array(l);
		return function (t: number, u: number, v: number, w: Float32Array, y: number) {
			t *= 256;
			u *= 256;
			for (var z = 0, x = 0, B = Math.pow(2, d) >> 0, A = 0; A < f; ++A) {
				let idx: any = 1;
				for (let C = 0; C < d; ++C) {
					let leftIdx = (t + p[z + 4 * idx + 0] * v >> 8) * y + (u + p[z + 4 * idx + 1] * v >> 8);
					let rightIdx = (t + p[z + 4 * idx + 2] * v >> 8) * y + (u + p[z + 4 * idx + 3] * v >> 8);

					let leftValue: boolean = w[leftIdx] <= w[rightIdx];
					let val: number;
					if (leftValue === true) val = 1;
					else val = 0;

					idx = 2 * idx + val;
				}
				let qValue: number = q[B * A + idx - B] as number;
				x += qValue;
				if (x <= r[A])
					return -1;
				z += 4 * B;
			}
			return x - r[f - 1];
		};
	};

	public run_cascade = function (b: any, g: any, a: any) {
		var d = b.pixels,
			f = b.nrows,
			h = b.ncols;
		b = b.ldim;
		var k = a.shiftfactor,
			l = a.maxsize,
			m = a.scalefactor;
		a = a.minsize;
		for (var n = []; a <= l;) {
			for (var p = Math.max(k * a, 1) >> 0, q = a / 2 + 1 >> 0, r = q; r <= f - q; r += p)
				for (var t = q; t <= h - q; t += p) {
					var u = g(r, t, a, d, b);
					if (0 < u)
						n.push([r, t, a, u]);
				}
			a *= m;
		}
		return n;
	};

	public cluster_detections = function (b: any, g: number) {
		function a(r: number[], t: number[]) {
			var u = r[0],
				v = r[1],
				w = r[2],
				y = t[0],
				z = t[1],
				x = t[2];
			u = Math.max(0, Math.min(u + w / 2, y + x / 2) - Math.max(u - w / 2, y - x / 2));
			v = Math.max(0, Math.min(v + w / 2, z + x / 2) - Math.max(v - w / 2, z - x / 2));
			return u * v / (w * w + x * x - u * v);
		}
		b = b.sort(function (r: number[], t: number[]) {
			return t[3] - r[3];
		});
		for (var d = Array(b.length).fill(0), f = [], h = 0; h < b.length; ++h)
			if (0 == d[h]) {
				for (var k = 0, l = 0, m = 0, n = 0, p = 0, q = h; q < b.length; ++q)
					if (a(b[h], b[q]) > g) {
						d[q] = 1;
						k += b[q][0];
						l += b[q][1];
						m += b[q][2];
						n += b[q][3];
						p += 1;
					}
				f.push([k / p, l / p, m / p, n]);
			}
		return f;
	};

	public instantiate_detection_memory = function (b: number) {
		let g = 0;
		const a: any[] = [];
		for (let d = 0; d < b; ++d)
			a.push([]);
		return function (f: any) {
			a[g] = f;
			g = (g + 1) % a.length;
			f = [];
			for (let i = 0; i < a.length; ++i)
				f = f.concat(a[i]);
			return f;
		};
	};

	public detectFace = function () {
		const self: any = this;
		var b = self.instantiate_detection_memory(15),
			g = function (a: number, d: number, f: number, h: number, k: number) {
				return -1;
			};
		fetch("https://facelivelinesssdk.s3.ap-south-1.amazonaws.com/fac").then(function (a) {
			a.arrayBuffer().then(function (d: any) {
				d = new Int8Array(d);
				g = self.unpack_cascade(d);
				const videoEl = <HTMLVideoElement>self.document.getElementById("webcam")
				var f = <HTMLVideoElement>videoEl.getElementsByTagName("video")[0];
				const canvas = self.document.createElement("canvas");
				canvas.width = parseInt(f.style.width);
				canvas.height = parseInt(f.style.height);
				var h = canvas.getContext("2d");
				self.detectinterval = setInterval(function () {
					// console.log("interval")
					f = <HTMLVideoElement>videoEl.getElementsByTagName("video")[0];
					$('#cameraModel').css('visibility', 'visible');
					$('#loader2').css('display', 'none');
					var k = parseInt(f.style.width),
						l = parseInt(f.style.height),
						m = self.getObjectFitSize(!1, k, l, f.videoWidth, f.videoHeight);
					h.drawImage(f, m.x, m.y, k * m.ratio, l * m.ratio, 0, 0, k, l);
					m = h.getImageData(0, 0, k, l).data;
					for (var n = new Uint8Array(l * k), p = 0; p < l; ++p)
						for (var q = 0; q < k; ++q)
							n[p * k + q] = (2 * m[4 * p * k + 4 * q] + 7 * m[4 * p * k + 4 * q + 1] + 1 * m[4 * p * k + 4 * q + 2]) / 10;
					const image = {
						pixels: n,
						nrows: l,
						ncols: k,
						ldim: k
					};
					const params = {
						shiftfactor: 0.1,
						minsize: Math.round(0.25 * k),
						maxsize: Math.round(0.6 * k),
						scalefactor: 1.1
					};
					let dets = self.run_cascade(image, g, params);
					dets = b(dets);
					dets = self.cluster_detections(dets, 0.2);
					const detectedFaces: number[] = [];
					for (let i = 0; i < dets.length; ++i) {
						if (!(5 > dets[i][3] || dets[i][2] < Math.round(0.35 * k))) {
							if (dets[i][2] > Math.round(0.50 * k)) {
								self.setfalsedetection = true;
							} else if (detectedFaces.length === 0) {
								detectedFaces.push(dets[i][1]);
							} else {
								const m = dets[i][1];
								if (!(0.2 >= parseFloat(Math.abs(1 - detectedFaces[detectedFaces.length - 1] / m).toFixed(2)))) {
									detectedFaces.push(m);
									break;
								}
							}
						} else {
							if ((dets[i][2] > Math.round(0.35 * k))) {
								self.setfardetection = true;
							} else if ((5 < dets[i][3])) {
								self.setfardetection = true;
							}
						}
					}
					if (detectedFaces.length === 1) {
						if (self.consecutiveDetections >= 15) {
							self.message = "You can capture your selfie now"
							$('#newmessage').css('color', 'green');
							$('.camaeraDivOvel').removeClass('redBorder').addClass('greenBorder');
							$("#selfieButtonIcon").prop("disabled", false)
							self.isSelfieCorrect = true;
						} else {
							self.consecutiveDetections++;
						}
					} else if (self.consecutiveDetections === 0) {
						$("#selfieButtonIcon").prop("disabled", true);
						$('#newmessage').css('color', 'red');
						$('.camaeraDivOvel').removeClass('greenBorder').addClass('redBorder');
						self.isSelfieCorrect = false;
						if (self.setfalsedetection === true) {
							self.setfalsedetection = false
							self.message = "You are too close to the Camera";
						} else if (self.setfardetection == true) {
							self.setfardetection = false;
							self.message = "You are too far from the Camera"
						} else {
							self.message = 'Place your face within the circle';
							self.isSelfieCorrect = false;
						}
					} else {
						self.consecutiveDetections--;
					}
				}, 16);
			});
		});
	};





	public handleInitError(error: WebcamInitError): void {
		const me = this;

		if (error.mediaStreamError && error.mediaStreamError.name === 'NotAllowedError') {
			console.warn('Camera access was not allowed by user!');
			$('#camera-denied-modal').modal('show');
			me.permissionDenied.emit();
		}

		this.showWebcam = false;
		setTimeout(() => {
			$('#camera-modal').modal('hide');
		}, 500);
	}

	public showNextWebcam(directionOrDeviceId: boolean | string): void {
		this.nextWebcam.next(directionOrDeviceId);
	}

	public handleImage(webcamImage: WebcamImage): void {
		clearInterval(this.detectinterval);
		this.pictureTaken.emit(webcamImage);
	}

	public cameraWasSwitched(deviceId: string): void {
		this.deviceId = deviceId;
	}

	public get triggerObservable(): Observable<void> {
		return this.trigger.asObservable();
	}

	public get nextWebcamObservable(): Observable<boolean | string> {
		return this.nextWebcam.asObservable();
	}
}
